import {
  Box,
  Button,
  CardContent,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  IconButton,
  Paper,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import ProjectImageTable from "../components/project/ProjectImageTable";
import ProjectImageContainer from "../components/project/ProjectImageContainer";
import { LabelModeless } from "../components/LabelModeless";
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import {
  classListState,
  filterModalPosState,
  historyModalPosState,
  openKeyModalState,
  projectImagesInfoState,
  selectedImageState,
  autoFillDataState,
  trainStatusInfoState,
  trainStatusState,
  ngCountState,
  isTutorialState,
  stepIndexState,
  currentStepsState,
  currentGroupState,
  isTutorialContinueState,
  dataLoadingState,
  tutorialState,
} from "../recoil";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { t } from "i18next";
import { PlayArrowIcon, SettingsIcon, StopIcon, TuneIcon } from "../icons";
import {
  editProject,
  getImagesByClass,
  getImageSort,
  getLabelHistory,
  getProject,
  getProjectGeneralInfo,
  startTrainProject,
} from "../services/projectService";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  checkProjectAIStatus,
  formatByTypeDate,
  formatDate,
  formatDateInSSE,
  formatHourByTime,
  imageFlat,
} from "../utils/utils";
import { matchPath, useParams } from "react-router-dom";
import ImageFilter, { filterDefault } from "../components/project/ImageFilter";
import { IResponseProjectData, ITrainData, ITrainStatusInfo } from "@types";
import CustomButton from "../components/customComponent/CustomButton";
import { FilterSettings } from "@types";
import { commonKeyData } from "../keyMapData/keyData";
import { editProjectConfig } from "../services/projectService";
import CircularWithVariable from "../components/CircularWithVariable";
import HighlightBox from "../components/customComponent/CustomHighlightBox";
import { ContainedButtonStyles, OutlinedButtonStyles } from "../styles/GlobalStyles";
import { toast } from "react-toastify";
import { SelectTrain } from "../components/project/ProjectModal";
import { useTrainHandler } from "../hooks/useTrainHandler";
import ProductTour from "../components/joyride/ProductTour";
import { steps_1_2, steps_2, steps_3, steps_4 } from "../components/joyride/step1";
import { func_userConfigUpdate } from "../utils/tutorialUtil";
import { useTutorial } from "../hooks/useTutorial";
import { isStateEqual } from "common-lib";
import { useTrainingStore } from "../stores/training.store";
import { filterSettingState } from "../recoil/filterAtoms";

export const initialProjectData = {
  id: 0,
  step: "분류",
  create_at: "",
  material_name: "",
  project_name: "",
  config: {
    keyConfig: commonKeyData.defaultClassKey,
    imgConfig: filterDefault,
    trainTargetLabel: "OK",
    trainConditionCount: 10,
    autoLabelingCondition: "+30",
    autoLabeling: true,
  },
  train: null,
  user: {
    id: 38,
    user_id: "admin",
  },
  NGCount: 0,
  class: [],
  images: [],
  dataSet_id: 0,
};

interface ImageInfoItem {
  AILabel: string;
  ai_update_at: string;
  id: number;
  label: string;
  path: string;
  recentLabel: string;
  score: number;
  seq: number;
}

export default function ProjectPage() {
  const { id, label } = useParams();
  const [historyModalPos, setHistoryModalPos] = useRecoilState(historyModalPosState);
  const [filterModalPos, setFilterModalPos] = useRecoilState(filterModalPosState);
  const [filterSetting, setFilterSetting] = useRecoilState(filterSettingState);

  const containerRef = useRef<HTMLDivElement>(null);
  const selectedData = useRecoilValue(selectedImageState);
  const [openHistoryModal, setOpenHistoryModal] = useState<boolean>(false);
  const [openFilterModal, setOpenFilterModal] = useState<boolean>(false);
  const [historyRows, setHistoryRows] = useState([]);
  const setOpenKeyModal = useSetRecoilState(openKeyModalState);
  const [switchFilterState, setSwitchFilterState] = useState(false);
  const [userConfig, setUserConfig] = useState<any>(null);
  const [projectConfig, setProjectConfig] = useState<any>(null);
  const [isClassKey, setIsClassKey] = useState<boolean>(false);
  const columns: GridColDef[] = [
    { field: "id", headerName: "순번", width: 50 },
    { field: "label", headerName: "라벨", width: 80 },
    { field: "author", headerName: "변경주체", width: 80 },
    { field: "create_at", headerName: "변경시간", width: 170 },
  ];
  const [etcKey, setEtcKey] = useState<string[]>([]);
  const [autoFillData, setAutoFillData] = useRecoilState<any>(autoFillDataState);
  const resetTrainStatus = useResetRecoilState(trainStatusState);
  const eventSourceRef = useRef<EventSource | null>(null); //ai-info-sse unmount관리
  const [isKeyUndefined, setIsKeyUndefined] = useState(false);
  const [isKeySettingModal, setIsKeySettingModal] = useState(false);
  const { isTraining } = useTrainingStore();
  const [isTrainable, setIsTrainable] = useState(false);
  const [ngCount, setNgCount] = useRecoilState(ngCountState);
  const location = useLocation();
  const [isLoadingData, setIsLoadingData] = useRecoilState(dataLoadingState);
  const { saveProgress } = useTutorial();

  useEffect(() => {
    const saved = localStorage.getItem("tutorialProgress");
    if (saved) {
      const { path, stepIndex, type, series } = JSON.parse(saved);
      if (location.pathname === path && isLoadingData) {
        saveProgress(stepIndex, series);
      }
      setIsLoadingData(false);
    }
  }, [location.pathname, isLoadingData]);

  useEffect(() => {
    resetTrainStatus();
  }, [id]);

  useEffect(() => {
    setOpenHistoryModal(false);
  }, [selectedData]);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    if (userInfo.config) {
      const userConfig = JSON.parse(userInfo.config);
      setUserConfig(userConfig);
    }
  }, []);

  // user config 추출함
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    const userEtcKey = JSON.parse(userInfo.config).etcKey;
    if (userEtcKey) {
      setEtcKey(userEtcKey.map((k: string) => k.replace(/[{}]/g, "").toLowerCase()));
      window.addEventListener("keydown", handleEtcKeyDown);
      return () => {
        window.removeEventListener("keydown", handleEtcKeyDown);
      };
    }
  }, [userConfig]);

  const openLabelHistory = async () => {
    setOpenHistoryModal((prev) => !prev);
    try {
      if (selectedData && !openHistoryModal) {
        const response = await getLabelHistory(selectedData.id!);
        console.log(response);
        const formattedRows = response.labelHistories.map((history: any, index: number) => ({
          ...history,
          id: index + 1,
          create_at: formatDate(history.create_at),
        }));
        setHistoryRows(formattedRows);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleEtcKeyDown = (event: KeyboardEvent) => {
    const key = event.key.toLowerCase();

    if (etcKey.includes(key)) {
      event.preventDefault();
    }

    if (etcKey.includes(key)) {
      setSwitchFilterState((prevState) => !prevState);
    }
  };

  // 프로젝트 이미지 테이블

  const [page, setPage] = useState(1);
  const [images, setImages] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useRecoilState(selectedImageState);
  const [projectImagesInfo, setProjectImagesInfo] = useRecoilState(projectImagesInfoState);

  const [projectData, setProjectData] = useState<IResponseProjectData>(initialProjectData);
  const [aiLabelList, setAiLabelList] = useState<any>([]);
  // const [inspResult, setInspResult] = useState<any>([]);
  const [trainStatus, setTrainStatus] = useRecoilState<trainStatusResponse>(trainStatusState);
  const loadMoreImages = async () => {
    setLoading(true);
    try {
      // await getImageSort(Number(id));
      const response = await getProjectGeneralInfo(Number(id));
      setProjectData(response.project);
      setNgCount(response.project.NGCount);
      if (response.project.NGCount > 10) {
        setIsTrainable(true);
      }

      const imagesData = response.project.images as ImageInfoItem[];
      if (imagesData && imagesData.length > 0) {
        // setImages((prevImages) => [...prevImages, ...imagesData]);
        // const imagesFlatData = imageFlat(imagesData);
        // setSelectedRow(imagesFlatData[0]);
        setProjectImagesInfo((prevImages) => [...prevImages, ...imagesData]);

        // const aiLabelList = imagesData.map(({ id, AILabel, score }) => ({
        //   id,
        //   AILabel,
        //   score,
        // }));
        // setInspResult(aiLabelList);
      }
      setLoading(false);
      setIsLoadingData(true);
    } catch (error) {
      console.error("Failed to load images:", error);
    }
    // finally {
    //   setLoading(false);
    // }
  };

  useEffect(() => {
    if (projectData.config) {
      setProjectConfig(projectData.config);
    } else if (!projectData.config && projectData.id !== 0) {
      const classKey = commonKeyData.defaultClassKey;
      setProjectConfig(classKey);
      try {
        const saveDefaultConfig = async () => {
          await editProjectConfig(Number(id), classKey);
        };
        saveDefaultConfig();
      } catch (error) {
        console.error("Error updating project config:", error);
      }
    }

    if (projectData) {
      setAutoFillData([
        {
          step: "분석",
          material_name: projectData.material_name,
          project_name: projectData.project_name,
        },
      ]);
    }
  }, [projectData]);

  const {
    handleTrain,
    handleTrainChange,
    handleSelectTrain,
    handleStopTrain,
    trainOption,
    openSelectTrain,
    fetchAIServer,
    setOpenSelectTrain,
    fetchInspResult,
    inspResult,
    inspStatus,
  } = useTrainHandler({
    id,
    step: projectData.step,
    label,
    projectDataStep: projectData.step,
    t,
    // isTraining,
    // setIsTraining,
    isTrainable,
  });

  useEffect(() => {
    setProjectImagesInfo([]);
    loadMoreImages();
    fetchAIServer();
  }, [id]);

  useEffect(() => {
    // console.log("isTraining 변경:fetchAI함수 실행");
    if (isTraining) {
      fetchAIServer();
    } else {
      fetchInspResult();
    }

    return () => {
      if (eventSourceRef.current) {
        console.log("Unmount - Closing SSE");
        eventSourceRef.current.close();
      }
    };
  }, [isTraining, id]);

  const openKeyModal = () => {
    setOpenKeyModal(true);
    setIsKeySettingModal(true);
    setIsKeyUndefined(false);
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSwitchFilterState(event.target.checked);
  };

  const handleClose = () => {
    setOpenSelectTrain(false);
  };

  const handleAIServer = async () => {
    console.log("click");
  };

  return (
    <>
      {loading ? (
        // <CircularProgress />
        <Box
          sx={{
            border: "1px solid var(--icon-color)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "80vh",
            width: "100%",
            borderRadius: 2,
            mt: 2,
            mb: 2,
          }}
          className="stepss"
        >
          <CircularProgress />
          <Typography sx={{ mt: 2, color: "var(--text-color)" }}>데이터를 로딩중입니다...</Typography>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              p: 2,
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              // height: "fit-content",
              height: "100%",
              border: "1px solid var(--dk-border, #ccc)",
              borderRadius: 2,
              mt: 2,
              mb: 2,
            }}
            ref={containerRef}
            className="steps_2_8"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "40%",
                height: "100%",
              }}
              className="step2 steps_3_6"
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  height: "58px",
                  p: 1,
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                  borderBottomLeftRadius: "0px",
                  borderBottomRightRadius: "0px",
                  bgcolor: "var(--ic-header-bg-color)",
                  color: "var(--ic-header-color)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <Button onClick={handleAIServer} variant="outlined">
                      ai_server
                    </Button>
                  </Box>
                  <Box>
                    {isTraining ? (
                      <Tooltip title="학습 중단" placement="top">
                        <IconButton onClick={handleStopTrain}>
                          <StopIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="학습 실행" placement="top">
                        <IconButton onClick={handleTrain} className="steps_2_7" sx={{ color: "var(--icon-color)" }}>
                          <PlayArrowIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </Box>
              </Box>
              <ProjectImageTable
                id={Number(id)}
                projectData={projectData}
                userConfig={userConfig}
                label={label || ""}
                inspResult={inspResult}
                setAiLabelList={setAiLabelList}
                inspStatus={inspStatus}
              />
            </Box>
            <Box
              sx={{
                // mt: 3,
                // width: "790px",
                height: "100%",
                width: "100%",
                ml: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  height: "58px",
                  p: 1,
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                  borderBottomLeftRadius: "0px",
                  borderBottomRightRadius: "0px",
                  bgcolor: "var(--ic-header-bg-color)",
                  color: "var(--ic-header-color)",
                }}
              >
                <Box sx={{ display: "flex", gap: "20px" }} className="steps_2_2">
                  <FormControlLabel
                    control={<Switch checked={switchFilterState} onChange={handleSwitchChange} />}
                    label={t("Filter")}
                    labelPlacement="start"
                  />
                  <IconButton
                    sx={{
                      ml: 1,
                      borderRadius: "4px",
                      border: "1px solid var(--icon-color)",
                    }}
                    onClick={() => setOpenFilterModal((prev) => !prev)}
                  >
                    <TuneIcon sx={{ color: "var(--icon-color)" }} />
                  </IconButton>
                </Box>
                <Box sx={{ display: "flex", gap: "5px" }}>
                  <StatusBox id={id} trainStatus={trainStatus} inspStatus={inspStatus} />
                  <Box className="steps_2_3">
                    <CustomButton text={t("LabelHistory")} variant="outlined" onClick={openLabelHistory} />
                  </Box>
                  <Box className="steps_2_4">
                    <CustomButton text={t("KeySetting")} variant="outlined" onClick={openKeyModal} />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  background: "var(--secondary-bg-color)",
                  borderBottomLeftRadius: "16px",
                  borderBottomRightRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "93%",
                  // flex: 1,
                }}
                className="step3"
              >
                <ProjectImageContainer
                  projectData={projectData}
                  filterStatus={switchFilterState}
                  filterSetting={filterSetting}
                  projectConfig={projectConfig}
                  userConfig={userConfig}
                  setUserConfig={setUserConfig}
                  setProjectConfig={setProjectConfig}
                  setIsClassKey={setIsClassKey}
                  setIsKeyUndefined={setIsKeyUndefined}
                  setIsKeySettingModal={setIsKeySettingModal}
                  isKeySettingModal={isKeySettingModal}
                  setIsTrainable={setIsTrainable}
                />
              </Box>
            </Box>
            <LabelModeless
              open={openFilterModal}
              position={filterModalPos}
              setModalPos={setFilterModalPos}
              containerRef={containerRef}
              width={400}
              height={500}
            >
              <DialogContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  bgcolor: "var(--label-modal-bg)",
                  width: "100%",
                  height: "100%",
                  color: "var(--text-color)",
                }}
              >
                <ImageFilter />
              </DialogContent>
            </LabelModeless>
            <LabelModeless
              open={openHistoryModal}
              position={historyModalPos}
              setModalPos={setHistoryModalPos}
              containerRef={containerRef}
              width={370}
              height={450}
            >
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <DataGrid
                  hideFooter
                  disableColumnResize
                  rows={historyRows}
                  columns={columns}
                  sx={{
                    width: "370px",
                    height: "450px",
                    overflow: "auto",
                    backgroundColor: "var(--dk-surface, #fff)",
                    "& .MuiDataGrid-columnHeader": {
                      // backgroundColor: "#1976d2",
                      color: "var(--dg-color)",
                    },
                    "& .MuiDataGrid-filler": {
                      // backgroundColor: "#1976d2",
                      color: "var(--dg-color)",
                    },
                  }}
                />
                <Button onClick={() => setOpenHistoryModal(false)} variant="contained">
                  {t("Close")}
                </Button>
              </Box>
            </LabelModeless>
          </Box>
          {openSelectTrain && (
            <Dialog open={openSelectTrain} onClose={handleClose}>
              <Paper
                sx={{
                  width: "600px",
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignContent: "center",
                    gap: "20px",
                    p: "20px",
                  }}
                >
                  <SelectTrain selectedTrain={null} onTrainChange={handleTrainChange} />
                </CardContent>
                <Button onClick={handleSelectTrain}>{t("Edit")}</Button>
                <Button onClick={() => setOpenSelectTrain(false)}>{t("Close")}</Button>
              </Paper>
            </Dialog>
          )}
        </>
      )}
    </>
  );
}

const StatusBox = ({
  id,
  trainStatus,
  inspStatus,
}: {
  id: string | undefined;
  trainStatus: trainStatusResponse;
  inspStatus: InspStatusItem | null;
}) => {
  return (
    <Box sx={{ display: "flex", gap: "5px" }}>
      {trainStatus.project_id === Number(id) &&
      trainStatus.state !== "end" &&
      !isStateEqual(trainStatus.state, "none") ? (
        // 학습 상태 표시
        <Tooltip
          title={`남은시간: ${formatHourByTime(trainStatus.total_time - trainStatus.train_time)}`}
          placement="top"
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              border: "1px solid var(--icon-color)",
              borderRadius: 2,
              width: "fit-content",
              p: 1,
            }}
            className="steps_3_7"
          >
            {trainStatus.state === "train" ? (
              <>
                <Typography>학습 진행중</Typography>
                <CircularWithVariable
                  value={(trainStatus.train_time / trainStatus.total_time) * 100 || 0}
                  size="30px"
                />
              </>
            ) : trainStatus.state === "init" ? (
              <>
                <Typography>대기중</Typography>
                <CircularProgress size="30px" />
              </>
            ) : trainStatus.state === "calc" ? (
              <>
                <Typography>학습을 위한 계산중</Typography>
                <CircularProgress size="30px" />
              </>
            ) : (
              <>
                <Typography>{trainStatus.state}</Typography>
                <CircularProgress size="30px" />
              </>
            )}
          </Box>
        </Tooltip>
      ) : inspStatus ? (
        // 검사 상태 표시
        inspStatus.state !== "end" && inspStatus.state !== "cancel" ? (
          <Box
            sx={{
              display: inspStatus.state === "none" ? "none" : "flex",
              alignItems: "center",
              gap: "3px",
              border: "1px solid var(--icon-color)",
              borderRadius: 2,
              p: 1,
            }}
            className="steps_3_7"
          >
            {inspStatus.state === "init"
              ? "검사 대기중"
              : inspStatus.state === "calc"
                ? "검사를 위한 계산중"
                : inspStatus.state === "inspection"
                  ? "검사 진행중"
                  : ""}
            {inspStatus.state === "inspection" ? (
              <Box>
                <CircularWithVariable value={(inspStatus.count / inspStatus.total_count) * 100 || 0} size="30px" />
              </Box>
            ) : (
              <CircularProgress size="30px" />
            )}
          </Box>
        ) : inspStatus.state === "cancel" ? (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "3px",
                border: "1px solid var(--icon-color)",
                borderRadius: 2,
                p: 1,
              }}
              className="steps_3_7"
            >
              <Typography variant="body2">오류로 인해 검사 취소</Typography>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "3px",
              border: "1px solid var(--contained-bg)",
              borderRadius: 2,
              p: 1,
            }}
            className="steps_3_7"
          >
            <Typography variant="body2" sx={{ color: "var(--contained-bg-active)" }}>
              {t("RecentInspectionCompletedAt")}:{formatDate(inspStatus.update_at)}
            </Typography>
          </Box>
        )
      ) : null}
    </Box>
  );
};
